<template>
    <div style="margin-bottom: 50px;">
        <!--star(2022.08.16)-->
        <div class="box_c box_mt20">
            <h2 class="font_22 font_b th_text">公告编号：<span v-text="xmjyxq.ggh"></span></h2>
            <h4 class="font_16 box_mt5 th_text">宗地名称：<span v-text="xmjyxq.xmmc"></span></h4>
            <!--滚动公告-->
            <div class="yellow-notice-bar auction_yellow_bj" v-if="jjxq.sfjjz===1 && xsjjPop">
                <span class="auction_ann_icon icon_public box_mr5"></span>
                <div class="yellow-notice-bar-container" id="noticeMarquee">
                    <div class="yellow-notice-bar-marquee text">系统现已进入延时竞价环节，在此期间若任意竞买人有新的出价则所有竞买人立即进入延时竞价阶段</div>
                </div>
            </div>
            <!--滚动公告-->
        </div>
        <!--end居中-->
        <div class="clearfix2 box_mt20">
            <div class="fl w_580 box_sizing auction_box_border round_r10 min_h420 auction_blue_bj">
                <div class="auction_th auction_blue_bj_light box_ph10 round_rt10 box_pr25 white_text clearfix2">
                    <div class="fr box_pt6" v-if="jjxq.sfjjz===1 && xsjjPop">
                        <a id="bidRemindBtn" href="javascript:void(0);" class="auction_pink_bj white_text font_b auction_tips_btn round_m box_sizing box btn_circle">
                            <div class="button-fade-circle"></div>
                            <span class="auction_btn_icon icon_public"></span>
                            <span class="text_m">延时竞价提醒</span>
                        </a>
                    </div>
                    <div class="r_cell">
                        <h4 class="font_22 font_b">
                            <span class="icon_public auction_th_icon box_sizing box_mr10"><span class="icon_public auction_th_icon_i"></span></span>
                            <b class="text_m" v-text="currentStatus">正在挂牌</b></h4>
                    </div>
                </div>
                <!--end标题-->
                <div class="box_pw20 box_pt20">
                    <h4 class="font_22 font_b th_text white_text">当前最新出价</h4>
                    <div class="box_mt15 box_mw50 white_bj box_sizing box_ph20 box_c round_r4" v-if="jjxq.dqzgj && !noCj">
                        <span class="text_m font_48 blue_text big_num th_text_s" v-text="jjxq.dqzgj">346353.00</span>
                        <b class="font_22 text_m box_ml10" v-text="detail.jgdwText">万元</b>
                    </div>
                    <div class="box_mt15 box_mw50 white_bj box_sizing box_ph20 box_c round_r4" v-else>
                        <span class="text_m font_48 blue_text big_num th_text_s">暂无报价</span>
                        <b class="font_22 text_m box_ml10"></b>
                    </div>

                    <h4 class="font_22 font_b th_text white_text box_mt40">
                        <span v-text="currentTimeTips"></span>（服务器时间）
                    </h4>
                    <!--star时间插件-->
                    <div class="data-show-box box_mt20 font_22 white_text box_c" id="dateShow1">
                        <span class="date-tiem-span d box_sizing font_32 big_num blue_text round_r4 white_bj" v-text="jjxq.day">0</span><span class="text_m box_mw5">天</span>
                        <span class="date-tiem-span h box_sizing font_32 big_num blue_text round_r4 white_bj" v-text="jjxq.hour">0</span><span class="text_m box_mw5">:</span>
                        <span class="date-tiem-span m box_sizing font_32 big_num blue_text round_r4 white_bj" v-text="jjxq.minute">0</span><span class="text_m box_mw5">:</span>
                        <span class="date-s-span s box_sizing font_32 big_num blue_text round_r4 white_bj" v-text="jjxq.second">0</span>
                    </div>
                    <!--end时间插件-->
                </div>
                <!--end内容-->
            </div>
            <!--end一行左边-->
            <div class="fr w_580 box_sizing auction_box_border round_r10 min_h420">
                <div class="auction_th auction_blue_bj_light box_ph10 round_rt10 box_pr25 white_text clearfix2">
                    <h4 class="font_22 font_b">
                        <span class="icon_public auction_th_icon box_sizing box_mr10"><span class="icon_public auction_th_icon_i auction_th_icon_i2"></span></span>
                        <b class="text_m">出价记录</b></h4>
                </div>
                <!--end标题-->
                <div class="box_pw12">
                    <div class="h_300" v-if="!noCj">
                        <table class="auction_table box_c">
                            <thead>
                            <tr class="blue_text">
                                <th>出价序号</th>
                                <th>价格 (<span v-text="detail.jgdwText"></span>)</th>
                                <th>时间</th>
                            </tr>
                            </thead>
                            <tbody class="font_12">
                            <tr v-for="data in currentJjjl" :key="data.xh">
                                <td v-text="data.xh"></td>
                                <td>&yen;<span v-text="data.quotePrice"></span></td>
                                <td v-text="data.quoteTime"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="auction_table h_300 box_c tips" v-else>
                        <div class="tips-center">暂无出价记录</div>
                    </div>
                    <dl class="clearfix2 box_line_t box_pt6 box_mt5 box_pw12" v-if="!noCj">
                        <dt class="fr auction_page">
                            <a href="javascript:void(0);" :class="{disabled:pageSize===0 || currentPage===1}" @click="prePage">&lt; 上一页</a>
                            <a href="javascript:void(0);" :class="{active:currentPage === i}" v-for="i in pageSize" :key="i" v-text="i" @click="currentPage=i"></a>
                            <a href="javascript:void(0);" :class="{disabled:pageSize===0 || currentPage===pageSize}" @click="nextPage">下一页 &gt;</a></dt>
                        <dd class="r_cell">仅显示最新20条</dd>
                    </dl>
                </div>
                <!--end内容-->
            </div>
            <!--end一行左边-->
        </div>
        <!--end一行-->
        <!--end(2022.08.16)-->
    </div>
    <!--end竞买信息-->
</template>

<script>
    import {api} from '@/core/api'

    export default {
        name: "Jmxx",
        props: ["detail"],
        data() {
            return {
                xmjyxq: {  //交易项目信息
                    "ywlxID": "",
                    "bmjgID": "",
                    "jjsID": "",
                    "ggh": "",
                    "xmmc": "",
                    "zybh": "",
                    "ghyt": "",
                    "ssqy": "",
                    "jyfs": "",
                    "gpqssj": "",
                    "gpjzsj": "",
                    "qsj": "",
                    "zjfd": "",
                    "jgdw": "",
                    "jgfs": "",
                    "sfydj": "",
                    "xmdj": "",
                    "jmh": "",
                    "jmr": "",
                    "djwy": "",
                    "fjy": "",
                    "zjfsCode": "",
                    "freeEndTime": "",
                    "timeLimitedBiddingCycle": "",
                    "timeLimitedBiddingCycleNum": "",
                    "cjjls": "", //当前最高价
                    "sfbmcg": "" //是否报名成功，2报名未成功，1报名已成功、
                },
                jjxq: {  //竞价信息
                    "dqzgj": "", //当前最高价
                    "wxcjNum": "", //我想出价数字
                    "woyaochujia": "",
                    "sdjj": "", //手动加价
                    "jjfs": "1",//加价方式
                    "cjbs": "0", //出价倍数
                    "jjjl": [], //竞价记录
                    "sfjjz": "0", //是否竞价中
                    "gpjzsj": "",
                    "day": "0", //剩余天数
                    "hour": "0", //小时
                    "minute": "0", //分钟
                    "second": "0", //秒
                    "cur_time": ""
                },
                xsjjPop: false,
                sfcj: null,
                dycxs: true,
                jjxqTimer: null,
                sfcjTimer: null,
                jyztCode: null,
                zt: "竞价未开始",
                currentPage: 1,
                zzyh: false
            }
        },
        mounted() {
            this.sfcj = this.detail.extData.sfpmcg;
            this.jyztCode = this.detail.extData.jyztCode;
            api.getXmjyxq({jyywlx: this.detail.jyywlxCode, jyID: this.detail.jyID}).then(response => {
                if (response.data !== undefined) {
                    this.xmjyxq = response.data;
                    this.jjxqTimer = setInterval(this.getJmxx, 500);
                }
            });
        },
        methods: {
            getJmxx() {
                api.getJmxx2({jyywlx: this.detail.jyywlxCode, jjsID: this.xmjyxq.jjsID}).then(response => {

                    if (response.code === 500) {
                        this.jjxq.sfjjz = 2;
                        clearInterval(this.jjxqTimer);
                        return;
                    }

                    if (response.data) {
                        let isPause = response.data.isPause;
                        if(isPause){
                            clearInterval(this.jjxqTimer);
                            this.jyztCode = response.data.jyztCode;
                            this.jjxq.dqzgj = response.data.dqzgj;
                            this.jjxq.jjjl = eval("(" + response.data.jjjl + ")");
                            this.jjxq.sfjjz = 2;
                            this.jjxq.day = "0";
                            this.jjxq.hour = "0";
                            this.jjxq.minute = "0";
                            this.jjxq.second = "0";
                            return;
                        }
                    }

                    if (this.jjxq.cur_time !== "" && this.xmjyxq.freeEndTime !== "") {
                        if (this.dycxs && this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.sfjjz === 1) {
                            this.xsjjPop = true;
                            this.dycxs = false;
                        }
                        if (this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.gpjzsj > this.jjxq.gpjzsj && response.data.sfjjz === 1) {
                            this.xsjjPop = true;
                        }
                    }
                    if (response.data) {
                        this.jjxq.dqzgj = response.data.dqzgj;
                        this.jjxq.jjjl = eval("(" + response.data.jjjl + ")");
                        if (this.xmjyxq.sfjjz === 2) {
                            this.jjxq.sfjjz = 2;
                        } else {
                            this.jjxq.sfjjz = response.data.sfjjz;
                        }
                        this.jjxq.gpjzsj = response.data.gpjzsj;
                        this.zzyh = response.data.zzyh;
                        if (this.jjxq.sfjjz === 1) {
                            this.jjxq.day = response.data.day;
                            this.jjxq.hour = response.data.hour;
                            this.jjxq.minute = response.data.minute;
                            this.jjxq.second = response.data.second;
                            this.jjxq.cur_time = response.data.cur_time;
                        } else {
                            this.jjxq.day = "0";
                            this.jjxq.hour = "0";
                            this.jjxq.minute = "0";
                            this.jjxq.second = "0";
                            this.jjxq.cur_time = response.data.cur_time;
                        }

                        if (this.jjxq.sfjjz === 2) {
                            clearInterval(this.jjxqTimer);
                        } else if (this.jjxq.sfjjz === 3 && this.sfcj === null) {
                            this.jyztCode = "12";
                            this.sfcjTimer = setInterval(this.getSfcj, 1000);
                        } else {
                            this.jyztCode = response.data.jyztCode;
                            if (this.jyztCode === "10" || this.jyztCode === "11") {
                                clearInterval(this.jjxqTimer);
                                this.jjxq.sfjjz = 2;
                                this.jjxq.day = "0";
                                this.jjxq.hour = "0";
                                this.jjxq.minute = "0";
                                this.jjxq.second = "0";
                            }
                        }
                    }
                })
            },
            getSfcj() {
                api.getSfcj({jyywlx: this.detail.jyywlxCode, jjsID: this.xmjyxq.jjsID}).then(response => {
                    this.sfcj = response.data.sfpmcg;
                    this.jyztCode = response.data.jyztCode;
                    this.zzyh = response.data.zzyh;
                });
            },
            split_array(arr, len) {
                var a_len = arr.length;
                var result = [];   //结果数组
                for (var i = 0; i < a_len; i += len) {
                    result.push(arr.slice(i, i + len));
                }
                return result;
            },
            prePage() {
                if (this.currentPage > 1) {
                    this.currentPage -= 1;
                }
            },
            nextPage() {
                if (this.currentPage < this.pageSize) {
                    this.currentPage += 1;
                }
            },
        },
        beforeDestroy() {
            clearInterval(this.jjxqTimer);
            clearInterval(this.sfcjTimer);
        },
        computed: {
            noCj() {
                return this.jjxq.jjjl !== undefined && this.jjxq.jjjl !== null && this.jjxq.jjjl.length <= 0;
            },
            currentTimeTips() {
                if (this.jjxq.sfjjz === 1) {
                    return this.xsjjPop ? '延时竞价剩余时间' : '自由竞价剩余时间';
                }
                return "交易剩余时间";
            },
            currentStatus() {
                if (this.jjxq.sfjjz === 1) {
                    if (this.jjxq.cur_time <= this.xmjyxq.freeEndTime) {
                        return "正在挂牌";
                    } else {
                        return "延时竞价中";
                    }
                } else if (this.jjxq.sfjjz === 2) {
                    return this.zt;
                } else if (this.jjxq.sfjjz === 3) {
                    if (this.jjxq.jjjl.length > 0) {
                        if (this.sfcj === null) {
                            return this.zzyh ? "正在摇号，请稍等" : "交易结果正在确认，请稍等";
                        } else if (this.sfcj) {
                            return "已成交";
                        } else {
                            return "已流拍";
                        }
                    } else {
                        return "已流拍";
                    }
                } else {
                    return "";
                }
            },
            currentJjjl() {
                if (this.noCj) {
                    return [];
                }
                if (this.jjxq.jjjl.length > 10) {
                    return this.split_array(this.jjxq.jjjl, 10)[this.currentPage - 1];
                } else {
                    return this.jjxq.jjjl;
                }
            },
            pageSize() {
                return this.jjxq.jjjl.length > 10 ? Math.ceil(this.jjxq.jjjl.length / 10) : 1;
            }
        },
        watch: {
            'jjxq.sfjjz'(newValue, oldValue) {
                if (newValue === 3) {
                    clearInterval(this.jjxqTimer);
                } else if (newValue === 2) {
                    if (this.jyztCode === "10") {
                        this.zt = "已中止";
                    } else if (this.jyztCode === "11") {
                        this.zt = "已终止";
                    }
                }
            },
            sfcj(newValue, oldValue) {
                if (newValue !== null) {
                    clearInterval(this.sfcjTimer);
                }
            }
        }
    }
</script>
<style scoped>
    .tips {
        position: relative;
        text-align: center;
        color: #a6a6a6;
    }

    .tips-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>
